<template>
    <b-table-lite
        :items="items"
        :fields="fields"
        small
        borderless
        responsive
        thead-tr-class="border-bottom"
    >
        <template v-for="slotName in Object.keys($slots)" #[slotName]>
            <slot :name="slotName"></slot>
        </template>
        <template v-for="slotName in Object.keys($scopedSlots)" #[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps"></slot>
        </template>

        <template #cell(product)="data">
            <div class="d-flex flex-column gap-2">
                <b-link v-if="data.item.product" :to="{ name: 'Offers', query: { product: data.item.product } }">
                    {{ data.item.product }}
                </b-link>
                <div class="info text-secondary font-size-12">
                    {{ data.item.offerId }}
                </div>
            </div>
        </template>

        <template #cell(ean)="data">
            <b-link :to="{ name: 'Offers', query: { ean: data.item.ean } }">
                {{ data.item.ean }}
            </b-link>
        </template>

        <template #cell(name)="data">
            <div class="d-flex">
                <ImageLoader
                    :src="data.item.image"
                    alt=""
                    size="50"
                    image-height="auto"
                    class="mr-2 flex-shrink-0"
                />
                <div class="d-flex flex-column gap-2">
                    <b-link class="title" :to="createItemUrl(data.item)">
                        {{ data.item.name }}
                    </b-link>
                    <div class="info text-secondary font-size-12">
                        {{ data.item.categories.join(',') }}
                    </div>
                </div>
            </div>
        </template>

        <template #cell(feed)="data">
            <div class="d-flex flex-column gap-2">
                {{ data.item.feed }}
                <div v-if="data.item.campaign" class="info">
                    {{ data.item.campaign.name }}
                </div>
            </div>
        </template>

        <template #cell(price)="data">
            <div class="nowrap">
                {{ $format.currency(data.item.price) }}
            </div>
        </template>

        <template #cell(type)="data">
            {{ getTypeLabel(data.item.type) }}<br>
            <template v-if="data.item.format">{{ data.item.format }}</template>
        </template>

        <template #cell(hidden)="data">
            <BadgeBoolean :value="!!data.item.hidden" true-value-badge-variant="danger" false-value-badge-variant="success" />
        </template>

        <template #cell(active)="data">
            <div class="d-flex flex-column gap-2">
                <div><BadgeBoolean :value="!!data.item.active" :true-value-text="$t('available2')" :false-value-text="$t('unavailable2')" /></div>
                <div class="info text-secondary font-size-12">
                    {{ $format.dateAndHour(data.item.lastAvailabilityChangedAt, 'yyyy-MM-dd') }}
                </div>
            </div>
        </template>
    </b-table-lite>
</template>



<script>
    import BadgeBoolean from '@/components/common/BadgeBoolean.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'OffersTable',
        components: {
            BadgeBoolean,
            ImageLoader,
        },
        props: {
            items: {
                type: Array,
                required: true,
            },
            fields: {
                type: Array,
                default: () => [],
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        methods: {
            createItemUrl(item) {
                return {
                    name: 'OffersDetails',
                    params: { id: item.id, parentUrl: this.$route.fullPath },
                    query: {},
                };
            },
            getTypeLabel(type) {
                return this.parentComponent.typesAndFormats.find(item => item.value === type)?.label || type;
            },
        },
    };
</script>



<style lang="scss" scoped></style>
